import Main from '@/views/common/main'
// 账户管理中心
export default [
    //'系统管理'
    {
        path: '/userAdmin',
        name: 'userAdmin',
        meta: {
            icon: 'ios-apps',
            title: '系统管理'
        },
        component: Main,
        children: [
            // 后台用户管理
            {
                path: 'account',
                name: 'userAdmin_account',
                meta: { title: '后台用户管理' },
                component: () => import('@/views/permission/userAdmin/account.vue')
            },
            // 角色管理
            {
                path: 'adminRole',
                name: 'userAdmin_adminRole',
                meta: { title: '角色管理' },
                component: () => import('@/views/permission/userAdmin/adminRole.vue')
            },
            // 菜单管理
            {
                path: 'adminMenu',
                name: 'userAdmin_adminMenu',
                meta: { title: '菜单管理' },
                component: () => import('@/views/permission/userAdmin/adminMenu.vue')
            },
            //角色分类
            {
                path: 'adminClass',
                name: 'userAdmin_adminClass',
                meta: { title: '角色分类' },
                component: () => import('@/views/permission/userAdmin/adminClass.vue')
            },
            //白名单
            {
                path: 'whiteList',
                name: 'userAdmin_whiteList',
                meta: { title: '白名单登陆配置' },
                component: () => import('@/views/permission/userAdmin/whiteList.vue')
            },
            {
                path: 'operateRecord',
                name: 'userAdmin_operateRecord',
                meta: { title: '操作日志' },
                component: () => import('@/views/permission/userAdmin/operateRecord.vue')
            }
        ]
    }
]
// 数据报表
